<template>
	<div class="image-manager-wrap">
		<Modal 
			@close="close"
			class="image-manager"
			title="Image Manager"
			:width="1000"
		>
			<template #content>

				<div class="upload-image-wrap"><span class="large-button mini upload-image" @click="showUploader = true">Upload a new Image</span></div>
				
				<div :class="{'image-gallery':true,selectable:selectable}" v-if="images.length">
					<div v-for="(image, index) in images" :key="index" class="image-item" @click="selectImage(image)">
						<div class="image-preview">
							<div class="img"><img :src="dir+image.thumbnail" :alt="image.name" /></div>
							<span class="select"><span>Select image</span></span>
							<div class="image-actions">
								<button class="delete-btn" @click="removeImage(image)" title="Delete image">
									<span>×</span>
								</button>
							</div>
						</div>
						<span class="image-name">{{ image.name }}</span>
					</div>
				</div>

				<div v-else class="no-images" v-html="noImagesText" />
					
			</template>
		</Modal>
		<Uploader 
			v-if="showUploader" 
			:multiple="false" 
			@close-uploader="closeUploader"
			title="Image Upload"
			:fileTypes="['image']"
			:formData="uploadFormData"
			class="image-uploader"
		/>
	</div>
</template>

<script>
	import ApiService from "../services/api.service";
	import Uploader from "./Uploader.vue";
	import Icon from "./Display/Icon.vue"
	import Modal from "./Display/Modal.vue"
	import general from "../utils/general";
	export default {
		name: "ImageManager",
		components: {
			Uploader,
			Icon,
			Modal
		},

		props: {
			selectable:{
				type: Boolean,
				default: false
			},
			autoSelectUploaded: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				images: [],
				dir: '',
				loading: false,
				showUploader: false
			};
		},

		computed: {
			hasImages() {

				return this.images.length > 0;

			},
			uploadFormData () {

				return { type: 'image', vars:{ save: true } };

			},
			noImagesText () {
				return this.loading ? 'Loading images...' : 'No images uploaded yet';
			}
		},

		methods: {
			close() {
				this.$emit('close');
			},
			closeUploader(data) {
				this.showUploader = false;
				console.log('closeUploader',data);
				if ( data ) {
					this.getImages (data._id);
				}
			},
			removeImage(image) {

				this.$dialog
					.confirm("Delete this image?", { okText: "Yes", cancelText: "Cancel" })
					.then(
						function() {

							ApiService.delete(`images/${image._id}`)
								.then(
									function(info) {
										if ( info.data.deleted ) {
											this.getImages ();
										}
										else {this.selectable
											if ( info.data.foundIn ) {
												let places = [];
												info.data.foundIn.forEach(place => {
													places.push( `${place.reportName}: ${place.componentName}` );
													
												});
												general.$snotify (this,'html-error',"Couldn't delete image","Image in use: <br>" + places.join("<br>"))
											}
											else {
												this.$snotify.error("Error deleting image", "Couldn't delete image");
											}
										}
									}.bind(this)
								)
								.catch(
									function(err) {
										this.$snotify.error("Error deleting image", "Couldn't delete image");
									}.bind(this)
								);

						}.bind(this)
					)
					.catch(function() {});
			},
			async getImages ( selectId ) {
				try {
					this.loading = true;
					let response = await ApiService.get( `images` );
					this.images = response.data.items;
					this.dir = response.data.dir;
					this.loading = false;
					if ( selectId && this.autoSelectUploaded && this.selectable ) {
						this.selectImage(this.images.find(image => image._id === selectId));
					}
				}
				catch ( err ) {
					this.loading = false;
					this.$snotify.error("Error loading images", "Couldn't load images");
				}
				
			},
			selectImage(image) {
				if ( this.selectable) {
					this.$emit('selected',{ _id: image._id, thumbnail: this.dir + image.thumbnail, ext: image.ext });
					this.close();
				}
			}
		},

		mounted() {
			this.getImages ();
		},
	};
</script>

<style lang="less" scoped>
	@import "./../assets/css/less/_helper.less";
	@import "./../assets/css/less/_settings.less";

	.upload-image-wrap {
		text-align: center;
		.upload-image {
			margin: 0;
			font-size: 18px;
		}
	}
	.image-manager {
		.image-gallery {
			display: grid;
			grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
			gap: 1rem;
			margin-top: 1rem;
			.image-item {
				position: relative;
				text-align: center;

				.image-preview {
					position: relative;
					padding-bottom: 100%;
					background: #f5f5f5;
					border-radius: 4px;
					overflow: hidden;

					.img {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						object-fit: cover;
						display: flex;
						align-content: center;
						justify-content: center;
						img {
							max-width: 100%;
						}
					}

					.image-actions {
						position: absolute;
						top: 0.5rem;
						right: 0.5rem;
						display: none;
					}

					&:hover .image-actions {
						display: block;
					}
				}

				.image-name {
					display: block;
					margin-top: 0.5rem;
					font-size: 0.875rem;
					color: #666;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				.select {
					display: none;
					position: absolute;
					align-items: center;
					justify-content: center;
					width: 100%;
					height: 100%;
					background: rgba(255,255,255,0.8);
					span {
						color: @darkContrast;
						display: block;
						text-align: center;
					}
				}
			}

			&.selectable {
				.image-item {
					cursor: pointer;
					&:hover {
						img {
							
						}
						.select {
							display: flex;
						}
					}
				}
			}
		}

		.delete-btn {
			background: rgba(0, 0, 0, 0.5);
			color: white;
			border: none;
			border-radius: 50%;
			width: 24px;
			height: 24px;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;

			span {
				color: inherit;
			}

			&:hover {
				background: rgba(0, 0, 0, 0.7);
			}
		}

		.no-images {
			text-align: center;
			color: #666;
			padding: 2rem;
		}

	}
</style>
